<template>
  <v-form ref="form" v-model="valid" v-if="this.item!==null && this.item!==undefined">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <trans-textbox
            v-model="item"
            :label="$t('globals.name')"
            :rules="[$rules.required]"
            :disabled="disabled"
            field="Name"
            :dialog="dialog"
            class="required"
          ></trans-textbox>
        </v-flex>
        <v-flex xs12>
          <trans-textarea
            v-model="item"
            :label="$t('globals.description')"
            :disabled="disabled"
            field="Description"
            :dialog="dialog"
          ></trans-textarea>
        </v-flex>
        <v-flex xs12>
          <v-color-picker
            v-model="item.Color"
            label="Color"
            :rules="[$rules.required]"
            :disabled="disabled"
            mode="hexa"
            class="required"
          ></v-color-picker>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransTextbox from "../components/TransTextbox";
import TransTextarea from "../components/TransTextarea";
export default {
  name: "flag-form",
  components: {TransTextbox, TransTextarea},
  props: ["item", "disabled", "dialog"],
  mounted() {},
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapGetters("common", ["messages"])
  },
  watch: {
    valid: {
      handler(v) {
        //console.log("VALID---", v);
        this.$emit("valid-changed", v);
      },
      immediate: true
    },
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    isValid() {
      //console.log(this.valid)
      return this.valid;
    }
  }
};
</script>

<style>
</style>